import { useContext, useLayoutEffect, useRef } from 'react';

import {
  Flex,
  Form,
  FormContext,
  IPriceRangeMax,
  IPriceRangeMin,
  IPriceRange,
  PriceInputWithDropDown as BasePriceInputWithDropDown,
  IPriceInputDropDownProps,
  priceMaxRange,
  Devider,
  priceMinRange,
} from 'dash-ui';

import { FormFields } from 'containers/alerts/AddAlertModal/constants/constants';
import useValidation from 'containers/alerts/AddAlertModal/hooks/useValidation';
import MaskedInput from 'react-text-mask';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

function PriceInputWithDropDown({
  value,
  inputRef,
  ...props
}: IPriceInputDropDownProps) {
  useLayoutEffect(() => {
    // !!!important need delay here to allow blur finish before focus start
    setTimeout(() => {
      if (inputRef.current) {
        const inputElement = inputRef.current.inputElement as HTMLInputElement;
        inputElement.focus();
      }
    }, 1);
  }, [value]);

  return (
    <BasePriceInputWithDropDown value={value} inputRef={inputRef} {...props} />
  );
}

function PriceSection() {
  const { t } = useTranslation(['forms', 'forms', 'pages']);
  const theme = useTheme();
  const valid = useValidation();
  const { formState, formErrors, stateHandlers } = useContext(FormContext);
  const { max, min } = formState;
  const minRef = useRef<MaskedInput | null>(null);
  const maxRef = useRef<MaskedInput | null>(null);

  const handlePrice =
    (field: keyof IPriceRange) => (value: IPriceRangeMax | IPriceRangeMin) => {
      stateHandlers[field as FormFields](value);
      valid(field as FormFields, value);
    };

  return (
    <>
      <Flex alignItems="center" mt={2}>
        <Form.Group w="100%">
          <Form.Label>{t('labels.priceMin')}</Form.Label>
          <PriceInputWithDropDown
            value={min}
            onChangeValue={handlePrice('min')}
            placeholder="$0"
            range={priceMinRange(max)}
            inputRef={minRef}
            label="min"
          />
        </Form.Group>
        <Devider mx={2} mt={4} minWidth={17} h={1} color={theme.colors.n80} />
        <Form.Group w="100%">
          <Form.Label>{t('labels.priceMax')}</Form.Label>
          <PriceInputWithDropDown
            value={max}
            onChangeValue={handlePrice('max')}
            placeholder="Any Price"
            range={priceMaxRange(min)}
            inputRef={maxRef}
            label="max"
          />
        </Form.Group>
      </Flex>
      <Flex>
        <Form.Feedback
          $errorType={formErrors[FormFields.MinPropertyPrice]?.type}
        >
          {formErrors[FormFields.MinPropertyPrice]?.message}
        </Form.Feedback>
        <Form.Feedback
          $errorType={formErrors[FormFields.MaxPropertyPrice]?.type}
        >
          {formErrors[FormFields.MaxPropertyPrice]?.message}
        </Form.Feedback>
      </Flex>
    </>
  );
}

export default PriceSection;
